import React, { useState } from 'react';
import './BetaLogin.css';

const BetaLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check password against environment variable
    const correctPassword = process.env.REACT_APP_BETA_PASSWORD || 'LoveYour401k2024!';
    
    if (password === correctPassword) {
      // Store beta access in sessionStorage to match App.js
      sessionStorage.setItem('beta_authenticated', 'true');
      setError('');
      onLogin(true);
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  return (
    <div className="beta-login-container">
      <div className="beta-login-box">
        <h1>Love Your 401(k)</h1>
        <h2>Beta Access</h2>
        <p className="beta-subtitle">
          Enter your password to access the beta site
        </p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter beta password"
            autoFocus
          />
          
          {error && <div className="error">{error}</div>}
          
          <button type="submit">Access Beta</button>
        </form>
        
        <div className="contact">
          Need access? Contact <a href="mailto:admin@loveyour401k.com">admin@loveyour401k.com</a>
        </div>
      </div>
    </div>
  );
};

export default BetaLogin;
